import { useMutation, useQueryClient } from "react-query";
import { AvailabilityWorkspaceGroupData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useChangeWorkspaceGroupAvailabilityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: AvailabilityWorkspaceGroupData) =>
      workspaceService.changeGroupAvailability(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allGroups);
      },
    }
  );
};
